import PopularAddonsContent from "./popular-addons-content.jsx";
import { h, render } from "preact";
import storefront from "../../helpers/storefront/index.js";
import * as queries from "../../helpers/storefront/queries.js";

class PopularAddons extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.container = this.querySelector("[data-popular-addons-container]");

    this.init();
  }

  init = async () => {
    if (this.data.productsConfiguration?.length <= 0) return;

    const configOptions = await storefront.request({
      query: queries.products,
      variables: {
        ids: this.data.productsConfiguration.map((item) =>
          encodeId(item.id, "Product"),
        ),
      },
    });

    const PopularAddonsComponent = () => {
      return (
        <PopularAddonsContent
          data={this.data}
          form={this.closest("product-form")}
          group={this.groupSet}
          bundle={configOptions.data.nodes}
        />
      );
    };

    this.container && render(<PopularAddonsComponent />, this.container);
  };
}

if (!customElements.get("popular-addons")) {
  customElements.define("popular-addons", PopularAddons);
}
